module.exports = __webpack_public_path__ + "assets/img/bigcat_6_head.204e0952.png";